import React, { FunctionComponent } from 'react';
import { ErrorView } from './ErrorView';

export interface ErrorPropTypes {
  children: React.ReactNode;
}

export const Error: FunctionComponent<ErrorPropTypes> = (props) => {
  return <ErrorView {...props} />;
};
